import { render, staticRenderFns } from "./ReportDesktopAllSummary.vue?vue&type=template&id=320a554c"
import script from "./ReportDesktopAllSummary.vue?vue&type=script&lang=js"
export * from "./ReportDesktopAllSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports